<template>
    <modal :show.sync=show modalClasses="commission-slip-modal modal-hide-footer">
        <div id="payslip-details" class="commission-slips">
            <b-row class="mb-5">
                <b-col cols="12">
                    <img src="/img/sas-letter-head.png" class="img-fluid" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="7"
                    content-cols-md="6"
                    content-cols="5"
                    label="Staff Name:"
                    >
                        <b-form-input type="text" v-model="payslip.staff_name"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="8"
                    content-cols-md="6"
                    content-cols="4"
                    label="Display Name:"
                    >
                        <b-form-input type="text" v-model="payslip.display_name"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="5"
                    content-cols-md="6"
                    content-cols="7"
                    label="Staff IC:"
                    >
                        <b-form-input type="text" v-model="payslip.staff_nric"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="7"
                    content-cols-md="6"
                    content-cols="5"
                    label="Department:"
                    >
                        <b-form-input type="text" v-model="payslip.department"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="7"
                    content-cols-md="6"
                    content-cols="5"
                    label="Bank Name:"
                    >
                        <b-form-input type="text" v-model="payslip.bank_name"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="6"
                    content-cols-md="6"
                    content-cols="6"
                    label="Join Date:"
                    >
                        <b-form-input type="text" v-model="payslip.join_date"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="8"
                    content-cols-md="6"
                    content-cols="4"
                    label="Bank Account Number:"
                    >
                        <b-form-input type="text" v-model="payslip.bank_acc"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                    class="form-input"
                    label-cols-md="6"
                    label-align-md="right"
                    label-cols="8"
                    content-cols-md="6"
                    content-cols="4"
                    label="Release Date:"
                    >
                        <b-form-input type="text" v-model="payslip.release_date"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="commission-table">
                <b-table-simple responsive bordered>
                    <b-thead>
                        <b-tr variant="primary">
                            <b-th colspan="6">
                                <h2 class="text-uppercase text-xl text-center font-weight-800 mb-0">Commission Slips</h2>
                            </b-th>
                        </b-tr>
                        <b-tr class="text-center" variant="primary">
                            <b-th>Description</b-th>
                            <b-th>Earnings</b-th>
                            <b-th>Description</b-th>
                            <b-th>Deductions</b-th>
                            <b-th>YTD Description</b-th>
                            <b-th>YTD Earnings</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr>
                            <b-td>Commission</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.commission | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Advance Commission</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.commission | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Commission</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_commission | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Recruitment Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.recruitment_incentive | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Claw Back</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.clawback | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Recruitment Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_recruitment_incentive | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Title Overriding</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.title_overriding | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Operation Loss</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.operation_loss | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Title Overriding</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_title_overriding | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Elite Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.elite_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Co-Broke Commission</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.co_broke_commission | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Elite Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_elite_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Leadership Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.leadership_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Withholding</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.withholding | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Leadership Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_leadership_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Champion Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.champion_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                            <b-td>Other</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.other | moneyFormatter }}</span>
                            </b-td>
                            <b-td>YTD Champion Pool Incentive</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_champion_pool_incentive | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>Other</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.other | moneyFormatter }}</span>
                            </b-td>
                            <b-td></b-td>
                            <b-td></b-td>
                            <b-td>YTD Other</b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_other | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr class="font-weight-600">
                            <b-td></b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.earnings.total_earnings | moneyFormatter }}</span>
                            </b-td>
                            <b-td></b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.deductions.total_deductions | moneyFormatter }}</span>
                            </b-td>
                            <b-td></b-td>
                            <b-td>
                                <span>RM</span>
                                <span class="float-right">{{ payslip.ytd_earnings.ytd_total_earnings | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                    <b-tfoot>
                        <b-tr variant="primary">
                            <b-td colspan="3">
                                <span class="text-lg font-weight-700">Total Comm Earning</span>
                                <span class="float-right text-lg font-weight-500">RM {{ payslip.total_comm_earning | moneyFormatter }}</span>
                            </b-td>
                            <b-td colspan="3">
                                <span class="text-lg font-weight-700">Total Deduction</span>
                                <span class="float-right text-lg font-weight-500">RM {{ payslip.total_comm_deductions | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td colspan="3" rowspan="2" class="text-center" style="vertical-align: middle;">
                                <h3 class="text-uppercase text-xl text-center font-weight-800 mb-0">Confidential</h3>
                            </b-td>
                            <b-td colspan="3" variant="primary">
                                <span class="text-lg font-weight-700">RM</span>
                                <span class="float-right text-lg font-weight-500">RM {{ payslip.total_comm_earning | moneyFormatter }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td colspan="3">
                                <p class="text-center font-weight-600 font-italic">Four Thousand Six Hundred Fifty-Nines and Twenty-Six Cents</p>
                            </b-td>
                        </b-tr>
                    </b-tfoot>
                </b-table-simple>
            </div>
            <b-row class="my-5">
                <b-col cols="12">
                    <h3 class="text-center ">This is a computer generated document. No signature is required</h3>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props: {
        show_payslip_details: Boolean,
        payslip_details: Object
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.show_payslip_details;
            },
            set(newVal) {
                this.$emit('update:show_payslip_details', newVal);
            },
        },
    },
    data() {
        return {
            payslip: {
                staff_name: '',
                display_name: '',
                staff_nric: '',
                department: '',
                bank_name: '',
                join_date: '',
                earnings: {
                    commission: 4659.26,
                    recruitment_incentive: 0,
                    title_overriding: 0,
                    elite_pool_incentive: 0,
                    leadership_pool_incentive: 0,
                    champion_pool_incentive: 0,
                    other: 0,
                    total_earnings: 0,
                },
                deductions: {
                    advance_commission: 0,
                    clawback: 0,
                    operation_loss: 0,
                    co_broke_commission: 0,
                    other: 0,
                    total_deductions: 0,
                },
                ytd_earnings: {
                    ytd_commission: 9318.52,
                    ytd_recruitment_incentive: 0,
                    ytd_title_overriding: 0,
                    ytd_elite_pool_incentive: 0,
                    ytd_leadership_pool_incentive: 0,
                    ytd_champion_pool_incentive: 0,
                    ytd_other: 0,
                    ytd_total_earnings: 0,
                },
                total_comm_earning: 4659.26,
                total_comm_deductions: 0
            },
        }
    }
}
</script>